// frontend/app/locales/es.ts
export const es = {
  sidebar: {
    main: "Principal",
    planning: "Planificación",
    closings: "Cierres",
    system: "Sistema",
    dashboard: "Panel",
    transactions: "Transacciones",
    investments: "Inversiones",
    calendar: "Calendario",
    recurring: "Recurrentes",
    envelopes: "Sobres",
    debts: "Deudas y Créditos",
    goals: "Objetivos",
    documents: "Buzón de Telegram",
    balance: "Balances",
    data: "Datos",
    settings: "Ajustes",
    logout: "Cerrar sesión",
    login: "Iniciar sesión",
    language: "Idioma",
    more: "Más",
    home: "Inicio",
    expenses: "Gastos",
    envelopes_short: "Sobres",
    wishlist: "Deseos",
  },
  settings: {
    title: "Ajustes",
    subtitle: "Gestiona tus preferencias, perfil y credenciales de seguridad.",
    profile: "Perfil Personal",
    preferences: "Preferencias del Sistema",
    security: "Seguridad",
    database_status: "Estado de la Base de Datos",
    export_import: "Exportar e Importar",
    email_briefings: "Boletines Diarios e Informes",
    save: "Guardar Ajustes",
    change_password: "Cambiar Contraseña",
    current_password: "Contraseña Actual",
    new_password: "Nueva Contraseña",
    confirm_password: "Confirmar Contraseña",
    bio_authentication: "Autenticación Biométrica (Passkeys)",
    register_passkey: "Registrar Passkey",
    db_status_msg: "La base de datos PostgreSQL está activa y sincronizada correctamente.",
    export_btn: "Exportar Datos JSON",
    import_btn: "Importar Datos JSON",
    receive_briefings: "Recibir boletín matutino",
    receive_weekly: "Recibir informe semanal",
    receive_monthly: "Recibir informe mensual",
    base_currency: "Moneda Base",
    timezone: "Zona Horaria",
    personal_info: {
      username: "Nombre de usuario",
      email: "Correo electrónico",
      first_name: "Nombre",
      last_name: "Apellido",
      date_of_birth: "Fecha de nacimiento",
      phone_number: "Número de teléfono",
      address: "Dirección",
      city: "Ciudad",
      state: "Estado / Provincia",
      postal_code: "Código Postal",
      country: "País",
      gender: "Género",
      select_gender: "Seleccionar...",
      male: "Masculino",
      female: "Femenino",
      other_gender: "Otro",
      address_details: "Detalles (Edificio, Apartamento)",
      address_details_placeholder: "Ej. Apt 4B",
      address_placeholder: "Ej. Calle Principal 123",
      city_placeholder: "Nueva York",
      state_placeholder: "NY",
      postal_code_placeholder: "10001",
      job_section: "Empleo e Impuestos",
      tax_id: "Identificación Fiscal",
      tax_id_placeholder: "SSN o similar...",
      employment_status: "Situación Laboral",
      employment_status_placeholder: "Empleado, Freelancer...",
      job_title: "Título del Puesto",
      job_title_placeholder: "Ingeniero de Software..."
    },
    telegram: {
      title: "Integración con Bot de Telegram",
      desc: "Para usar el bot, envíale el comando {cmd} para conocer tu ID, luego ingrésalo a continuación.",
      placeholder: "Ej. 123456789"
    },
    password_section: {
      title: "Contraseña de Acceso",
      desc: "Actualiza tu contraseña regularmente para mantener tu cuenta segura.",
      btn: "Cambiar Contraseña",
      modal_title: "Cambiar Contraseña",
      cancel: "Cancelar",
      confirm: "Confirmar",
      saving: "Guardando..."
    },
    biometric: {
      title: "Inicio de Sesión Biométrico",
      desc: "Inicia sesión rápidamente usando Face ID, Touch ID o Windows Hello."
    },
    two_fa: {
      title: "Autenticación de Dos Factores (2FA)",
      status_active: "ACTIVO",
      desc: "Protege tu cuenta con un código de un solo uso generado por una aplicación de autenticación.",
      disable_btn: "Desactivar 2FA",
      enable_btn: "Configurar 2FA",
      modal_title: "Configurar 2FA",
      modal_desc: "Escanea este código con tu aplicación de autenticación (Google Authenticator, Authy, Raivo, etc.)",
      manual_entry: "O ingresa manualmente el código secreto:",
      verify_label: "Ingresa el código para verificar",
      verify_btn: "Activar Ahora",
      verifying: "Verificando...",
      prompt_disable: "Ingresa el código 2FA para confirmar la desactivación:"
    },
    briefings: {
      morning_label: "Boletín Matutino",
      morning_desc: "Resumen de los gastos de ayer y próximos plazos.",
      weekly_label: "Resumen Semanal",
      weekly_desc: "Análisis del rendimiento del presupuesto cada semana.",
      monthly_label: "Resumen Ejecutivo",
      monthly_desc: "Declaración detallada del patrimonio neto mensual."
    },
    toasts: {
      qr_err: "Error al generar el Código QR",
      conn_err: "Error de conexión",
      two_fa_enabled: "¡Autenticación de dos factores activada!",
      invalid_code: "Código inválido",
      two_fa_disabled: "2FA desactivada.",
      disable_failed: "Código inválido. Desactivación fallida.",
      profile_saved: "¡Perfil actualizado!",
      save_err: "Error al guardar el perfil",
      pref_saved: "¡Preferencia guardada!",
      pref_save_err: "No se pudo guardar la preferencia.",
      export_success: "¡Datos exportados con éxito!",
      export_failed: "Error al exportar los datos.",
      passkey_todo: "La función de Passkey se restaurará aquí",
      password_mismatch: "¡Las nuevas contraseñas no coinciden!",
      password_changed: "¡Contraseña cambiada con éxito!",
      password_change_err: "Error al cambiar la contraseña",
      loading: "Cargando ajustes..."
    }
  },
  dashboard: {
    title: "Panel Financiero",
    subtitle: "Panel de Control del Patrimonio Neto",
    overview_tab: "Resumen",
    wealth_tab: "Patrimonio y FIRE",
    behavior_tab: "Comportamiento",
    history_tab: "Historial y Registros",
    forecast_tab: "Pronósticos",
    merchants_tab: "Comerciantes",
    budget_tab: "Presupuestos",
    seasonality_tab: "Estacionalidad",
    gamification_tab: "RPG Financiero",
    investments_tab: "Inversiones",
    view_as: "Ver como:",
    burn_rate: "Tasa de Gasto Diario",
    avg_ticket: "Ticket Promedio",
    micro_tx: "Síndrome del Café (<15€)",
    no_spend_days: "Días sin Gasto",
    runway: "Autonomía (Supervivencia)",
    years_to_fire: "Años para F.I.R.E.",
    fire_target: "Objetivo de Independencia",
    net_worth: "Patrimonio Neto",
    liquid: "Líquido",
    invested: "Invertido",
    locked_goals: "En Objetivos",
    velocity: "Velocidad de Riqueza",
    savings_rate: "Tasa de Ahorro",
    distribution: "Distribución de Cuentas",
    in_bank: "En Banco",
    unconfirmed_alert: "¡Tienes {count} transacciones esperando confirmación!",
    unconfirmed_sub: "Podrían ser suscripciones o entradas de Telegram.",
    go_to_tx: "Ir a Transacciones",
    net_worth_in_bank: "En Banco (Real):",
    net_worth_in_goals: "En Sobres:",
    net_worth_credits: "Créditos Pendientes:",
    net_worth_debts: "Deudas Pendientes:",
    current_month_balance_title: "Balance del Mes Actual",
    pacing_title: "Ritmo de Gasto del Mes",
    pacing_time: "Tiempo ({days}d)",
    pacing_spent: "Presupuesto gastado",
    eom_forecast_title: "Pronóstico del Fin de Mes",
    eom_forecast_sub: "Estimado basado en la Tasa de Gasto ({rate}/d)",
    financial_pressure_title: "Calendario y Presión Financiera",
    pressure_upcoming_7d: "Próximos (7d)",
    pressure_remaining_month: "Mes Restante",
    pressure_next_month: "Mes Siguiente",
    pressure_fixed_costs: "Gastos Fijos/Mes",
    outflows_plural: "{count} salidas",
    planned_plural: "{count} planificados",
    pressure_base_msg: "Presión base",
    wealth_breakdown: "Desglose de Riqueza",
    in_bank_label: "En banco: {amount}",
    credits_short: "{amount} Créditos",
    debts_short: "{amount} Deudas",
    wealth_velocity_label: "Velocidad de Riqueza: {amount} / día",
    savings_rate_label: "Tasa de Ahorro (Mes)",
    savings_rate_sub: "Objetivo: 20% | Tasa de Inversión: {rate}%",
    fire_projection_title: "Proyección F.I.R.E.",
    fire_years: "{years} años",
    fire_years_over_50: "> 50 años",
    fire_target_label: "Objetivo de Independencia: {amount}",
    runway_label: "Autonomía (Supervivencia):",
    runway_value: "{years} años",
    progression_12m: "Progresión de la Riqueza (12m)",
    account_distribution: "Distribución de Cuentas",
    of_which_locked: "(De los cuales {amount} bloqueados)",
    dow_title: "Gastos por Día de la Semana",
    dow_avg: "Promedio",
    weekend_weekday: "Fin de Semana vs. Día de Semana",
    weekday_label: "Lun-Vie",
    weekend_label: "Sáb-Dom",
    month_rhythm: "Ritmo Mensual",
    first_half_label: "Días 1-15",
    second_half_label: "Días 16-31",
    income_expense_ratio_title: "Relación Ingresos / Gastos (Todo el Tiempo)",
    ratio_desc: "Por cada 1€ gastado, ganas {ratio}€",
    tx_count_label: "{count} tx",
    lifetime_flow: "Flujo de Caja Histórico",
    lifetime_flow_desc: "Dinero que ha pasado a través de la cuenta desde el primer día.",
    generated_label: "Generado",
    burned_label: "Gastado",
    monthly_income_history: "Historial Mensual de Ingresos (Todo el Tiempo)",
    monthly_expense_history: "Historial Mensual de Gastos (Todo el Tiempo)",
    monthly_income_tooltip: "Ingreso Total",
    monthly_expense_tooltip: "Gasto Total",
    top_expense_categories: "Categorías de Gasto Principales (Todo el Tiempo)",
    top_income_categories: "Principales Fuentes de Ingreso (Todo el Tiempo)",
    hall_of_fame: "Salón de la Fama",
    max_single_expense: "Mayor Gasto Único",
    max_single_income: "Mayor Ingreso Único",
    worst_day: "Peor Día",
    max_no_spend_streak: "Racha Máxima de No Gasto",
    days_suffix: "{days} d",
    days_suffix_streak: "{days} días 🔥",
    table: {
      year: "Año",
      income: "Ingresos",
      outflows: "Salidas",
      net_savings: "Ahorro Neto",
      pct_sav: "% Aho"
    },
    time_horizon: "Horizonte Temporal",
    years_label: "{years} Años",
    annual_return: "Rendimiento Anual de la Inversión",
    capital_invested_compound: "Capital Invertido (Interés Compuesto)",
    today_label: "Hoy",
    gain_label: "ganancia",
    liquidity_growth: "Liquidez (Crecimiento Lineal)",
    avg_savings_label: "Ahorro promedio: {amount}/mes",
    projected_total_label: "Riqueza Total Proyectada",
    vs_today_label: "vs. Hoy",
    trajectory_title: "Trayectoria de la Riqueza",
    invisible_tax_title: "Impuesto Invisible (Inflación 2%)",
    inflation_desc: "Tus {amount} actuales de liquidez, si se mantienen inactivos durante {years} años, perderán poder adquisitivo por un valor equivalente a:",
    year_n: "Año {n}",
    merchants_controparte: "Contraparte",
    merchants_tx: "Transacciones",
    merchants_total: "Total ({type})",
    merchants_outflow: "Gastado",
    merchants_inflow: "Recibido",
    merchants_none: "No se encontraron contrapartes.",
    merchants_page: "Página {page} de {total}",
    merchants_prev: "Anterior",
    merchants_next: "Siguiente",
    merchants_by_amount: "Por Monto",
    merchants_by_freq: "Por Frecuencia",
    budget_delete_title: "Eliminar Presupuesto",
    budget_delete_msg: "¿Quieres eliminar el presupuesto para {category}?",
    budget_edit_title: "Editar Presupuesto",
    budget_new_title: "Establecer Nuevo Presupuesto",
    budget_cat_label: "Categoría de Gastos",
    budget_select_placeholder: "Seleccionar...",
    budget_limit_label: "Límite Máximo (€)",
    budget_cancel: "Cancelar",
    budget_save: "Guardar",
    budget_spent_on: "Gasto del Presupuesto",
    budget_set_limit: "+ Establecer Límite",
    budget_empty: "Aún no has establecido presupuestos mensuales. Haz clic en \"Establecer Límite\" para comenzar.",
    budget_remaining: "Restante: {amount}",
    seasonality_title: "Gasto Histórico Promedio por Mes",
    rpg_title: "RPG Financiero",
    rpg_subtitle: "Tu HUD de comportamiento. Sobrevive al mes, supera tus récords, sube de nivel.",
    rpg_boss_title: "Espacio reservado para Boss Fights (Deudas) o Misiones",
    rpg_boss_sub: "Próximamente...",
    investments_value: "Valor Total",
    investments_capital: "Capital Invertido",
    investments_pnl: "P&L Total (No Realizado)",
    investments_positions: "Tus Posiciones",
    investments_tbl: {
      asset: "Activo",
      shares: "Acciones",
      pmc: "PMC",
      current_price: "Precio Actual",
      value: "Valor",
      pnl: "P&L"
    },
    sankey: {
      title: "Flujo de Caja Mensual ({month})",
      footer: "Ingresos ➔ Presupuesto Mensual ➔ Gastos / Ahorros",
      budget_mensile: "Presupuesto Mensual",
      risparmio: "Ahorros",
      avanzo: "Excedente",
      entrate: "Ingresos",
      spese: "Gastos",
      fondi_buste: "Sobres",
      erosione: "Erosión"
    },
    milestones: {
      title: "Los Pilares del Patrimonio",
      subtitle: "Tu camino a través de los hitos financieros a lo largo del tiempo.",
      reached: "Nivel Alcanzado",
      real_worth: "Patrimonio Neto Actual",
      next_target: "Próximo Objetivo: €{target}k"
    },
    streak: {
      title: "Racha de No Gasto",
      days: "Días",
      broken: "Gastaste hoy. La racha se ha roto.",
      promising: "Comienzo prometedor. ¡Sigue así!",
      rhythm: "¡Buen trabajo! Estás agarrando el ritmo.",
      unstoppable: "¡IMPARABLE! 🔥"
    },
    heatmap: {
      title: "Mapa de Comportamiento",
      generating: "Generando mapa...",
      outflows: "Salidas",
      inflows: "Entradas",
      balance: "Balance",
      mon: "Lun",
      wed: "Mié",
      fri: "Vie",
      jan: "Ene",
      feb: "Feb",
      mar: "Mar",
      apr: "Abr",
      may: "May",
      jun: "Jun",
      jul: "Jul",
      aug: "Ago",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Dic"
    }
  },
  transactions: {
    title: "Transacciones",
    subtitle: "Gestiona, filtra y añade tus movimientos.",
    filters: "Filtros",
    new_tx: "Nueva Transacción",
    search: "Buscar...",
    start_date: "Fecha de Inicio",
    end_date: "Fecha de Fin",
    category: "Categoría",
    account: "Cuenta",
    payment_method: "Método de Pago",
    type: "Tipo",
    status: "Estado",
    all: "TODO",
    income: "Ingreso",
    expense: "Gasto",
    transfer: "Transferencia",
    unconfirmed: "Por Confirmar",
    confirm_delete: "Eliminar Transacción",
    delete_msg: "¿Estás seguro de que quieres eliminar esta transacción? Esta acción es irreversible.",
    date: "Fecha",
    description: "Descripción",
    amount: "Monto",
    notes: "Notas",
    envelope: "Sobre",
    is_envelope_spending: "Gastar desde Sobre",
    currency: "Moneda",
    splits: "Dividir Gastos",
    contacts: "Contactos",
    new_btn: "+ Nuevo",
    confirm_btn: "Confirmar",
    edit_btn: "Editar",
    delete_btn: "Eliminar",
    no_tx_found: "No se encontraron transacciones con los filtros seleccionados.",
    loading_data: "Cargando datos...",
    today: "Hoy",
    yesterday: "Ayer",
    filter_bar: {
      from_date: "Desde la Fecha",
      to_date: "Hasta la Fecha",
      search_placeholder: "Ej. Amazon, Cena, Alquiler...",
      search_label: "Búsqueda Libre",
      category_placeholder: "Todas las Categorías",
      account_placeholder: "Todas las Cuentas",
      quick_filters_label: "Filtros Rápidos:",
      all: "Todo",
      today: "Hoy",
      last_7: "Últimos 7 días",
      this_month: "Este Mes",
      last_month: "Mes Pasado",
      only_unconfirmed: "Solo por Confirmar",
      found: "Encontrado:",
      delta: "Delta:"
    },
    modal: {
      edit_title: "✏️ Editar",
      new_title: "✨ Nuevo",
      type_expense: "Gasto",
      type_income: "Ingreso",
      type_transfer: "Transferencia",
      date_label: "FECHA",
      currency_label: "MONEDA",
      amount_label: "MONTO ({currency})",
      description_label: "DESCRIPCIÓN",
      real_bank_charge: "CARGO BANCARIO REAL ({currency})",
      bank_charge_sub: "Cuánto te cobró el banco realmente en tu estado de cuenta.",
      exchange_rate_label: "TIPO DE CAMBIO (Incluyendo Comisiones)",
      exchange_rate_sub: "Calculado matemáticamente por el sistema.",
      category_label: "CATEGORÍA",
      new_category_link: "+ Nuevo",
      merchant_label: "CONTRAREPARTE",
      new_merchant_link: "+ Nuevo",
      payment_method_label: "MÉTODO DE PAGO",
      new_payment_method_link: "+ Nuevo",
      money_movement_title: "MOVIMIENTO DE DINERO",
      new_account_btn: "+ Crear Nueva Cuenta",
      from_account_label: "PAGAR CON",
      from_account_transfer_label: "DESDE CUENTA",
      to_account_label: "DEPOSITAR EN",
      to_account_transfer_label: "A CUENTA",
      envelope_title: "✉️ SOBRES (Opcional)",
      envelope_label: "VINCULAR A SOBRE",
      envelope_placeholder: "Sin sobre...",
      use_envelope_money: "Usar Fondos del Sobre",
      use_envelope_money_sub: "Este gasto no afectará tu presupuesto mensual porque ya reservaste los fondos en el pasado.",
      debts_mode_label: "Generar deudas/créditos vinculados a esta transacción",
      debts_add_item: "+ Agregar Línea",
      debts_title: "Deudas / Créditos Vinculados",
      debts_empty: "Sin deudas vinculadas.",
      debts_new_btn: "+ Agregar Nuevo",
      notes_label: "NOTAS",
      tags_label: "Etiquetas (presiona Enter)",
      tags_placeholder: "Ej. vacaciones, regalo...",
      cancel_btn: "Cancelar",
      save_btn: "Guardar",
      saving_btn: "Guardando...",
      split_lent: "Lent",
      split_borrowed: "Deuda",
      split_to_whom: "¿A quién?",
      split_amount_placeholder: "Cuota (€)",
      split_credito: "CRÉDITO",
      split_debito: "DEUDA"
    },
    confirm_delete_title: "Eliminar Transacción",
    confirm_delete_msg: "¿Estás seguro de que deseas eliminar esta transacción? Esta acción es irreversible y los saldos serán recalculados.",
    quick_add_modal: {
      category_title: "Nueva Categoría ({type})",
      merchant_title: "Nueva Contraparte",
      payment_title: "Nuevo Método de Pago",
      name_placeholder: "Nombre...",
      cancel: "Cancelar",
      save: "Guardar"
    },
    new_account_modal: {
      title: "Nueva Cuenta",
      name_placeholder: "Nombre...",
      is_investment: "Cuenta de Inversión",
      create: "Crear",
      cancel: "Cancelar"
    }
  },
  auth: {
    login: {
      title: "MS Ledger",
      subtitle: "Protege tu patrimonio.",
      email_username: "Correo o Usuario",
      email_placeholder: "Ingresa tu correo",
      password: "Contraseña",
      forgot_password: "¿Olvidaste tu contraseña?",
      totp_code: "Código de Seguridad (2FA)",
      totp_placeholder: "000000",
      totp_desc: "Abre tu aplicación de autenticación para generar el código.",
      remember_me: "Recordarme por 30 días",
      submit_2fa: "Verificar e Iniciar Sesión",
      submit_password: "Iniciar Sesión con Contraseña",
      back: "Volver",
      or: "O",
      face_id: "Iniciar Sesión con Passkey"
    },
    register: {
      subtitle: "Crea una nueva cuenta para comenzar.",
      username: "Usuario",
      username_placeholder: "ej. mario99",
      email: "Correo electrónico",
      email_placeholder: "mario@email.com",
      password: "Contraseña",
      confirm_password: "Confirmar Contraseña",
      submit: "Registrarse",
      have_account: "¿Ya tienes una cuenta?",
      login_link: "Iniciar Sesión"
    },
    forgot_password: {
      title: "Restablecer Contraseña",
      desc: "Ingresa tu correo para recibir el enlace de restablecimiento.",
      email_placeholder: "Tu correo",
      submit: "Enviar Enlace",
      success: "¡Revisa tu correo! Hemos enviado las instrucciones."
    },
    reset_password: {
      title: "Nueva Contraseña",
      new_placeholder: "Nueva Contraseña",
      confirm_placeholder: "Confirmar Contraseña",
      submit: "Actualizar Contraseña"
    },
    errors: {
      email_required: "Ingresa tu Correo o Usuario antes de usar Face ID.",
      user_not_found: "Usuario no encontrado.",
      verification_failed: "La verificación falló.",
      biometric_error: "Error biométrico.",
      invalid_credentials: "Correo o contraseña inválidos",
      passwords_mismatch: "Las contraseñas no coinciden.",
      password_length: "La contraseña debe tener al menos 6 caracteres.",
      register_error: "Error durante el registro.",
      request_error: "Error durante la solicitud.",
      connection_error: "La conexión falló.",
      reset_error: "Error al restablecer la contraseña.",
      network_error: "Error de red.",
      success_register: "¡Registro completado! Redirigiendo a inicio de sesión...",
      success_reset: "¡Contraseña restablecida! Ya puedes iniciar sesión."
    }
  },
  balance: {
    title: "Cierres y Balances",
    subtitle: "Concilia los saldos de la aplicación con los saldos reales de tus extractos bancarios.",
    reconciliation_btn: "Iniciar Conciliación",
    calculating: "Calculando...",
    liquid_title: "Liquidez y Cuentas Corrientes",
    investments_title: "Inversiones",
    empty_msg: "Selecciona una fecha y haz clic en \"Iniciar Conciliación\" para comenzar.",
    toasts: {
      load_err: "Error al cargar los saldos.",
      diff_err: "El saldo de las cuentas líquidas debe coincidir exactamente con el saldo esperado (Delta = 0).",
      success_close: "¡Cuenta conciliada con éxito!",
      close_err: "Error: {detail}"
    },
    table: {
      account: "Cuenta",
      expected_balance: "Saldo Esperado en App",
      actual_balance: "Saldo Real Bancario",
      delta: "Delta",
      action: "Acción",
      close_btn: "Cerrar Cuenta",
      closed_status: "Conciliado",
      never_closed: "Nunca cerrado",
      last_closure: "Último: {date} ({amount})",
      copy_expected: "Copiar",
      copy_expected_mobile: "Copiar Esperado",
      expected_label_mobile: "Saldo Esperado",
      actual_label_mobile: "Saldo Bancario Real",
      close_btn_mobile: "Cerrar"
    }
  },
  calendar_page: {
    title: "Calendario",
    subtitle: "Vista diaria de flujo de caja con proyecciones de futuras suscripciones.",
    today: "Hoy",
    loading_events: "Cargando eventos...",
    toasts: {
      load_err: "Error al cargar los datos"
    },
    grid: {
      days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
      days_short: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"]
    }
  },
  data_page: {
    title: "Anagráficos",
    subtitle: "Configura categorías, cuentas, contrapartes y tarjetas.",
    search_placeholder: "Buscar elemento...",
    new_btn: "Nuevo",
    tabs: {
      categories: "Categorías",
      accounts: "Cuentas Bancarias",
      merchants: "Comerciantes",
      payment_methods: "Métodos de Pago",
      contacts: "Contactos"
    },
    table: {
      name: "Nombre del Elemento",
      type: "Tipo",
      account_type: "Tipo de Cuenta",
      actions: "Acciones",
      no_categories: "No se encontraron categorías.",
      no_accounts: "No se encontraron cuentas.",
      no_merchants: "No se encontraron contrapartes.",
      no_payments: "No se encontraron métodos de pago.",
      no_contacts: "No se encontraron contactos.",
      subcat_tooltip: "Añadir Subcategoría",
      investment_badge: "Inversión",
      liquidity_badge: "Liquidez"
    },
    modal: {
      delete_title: "Eliminar Elemento",
      delete_message: "¿Estás seguro de que quieres eliminar este elemento?",
      new_title: "Crear Nuevo Elemento",
      edit_title: "Editar Elemento",
      name_label: "Nombre",
      transaction_type: "Tipo de Transacción",
      type_expense: "Gasto",
      type_income: "Ingreso",
      type_transfer: "Transferencia",
      parent_label: "Subcategoría de (Opcional)",
      parent_none: "-- Ninguno (Categoría Principal) --",
      is_investment: "Cuenta de Inversión",
      is_investment_sub: "Excluye esta cuenta de los cálculos de liquidez de efectivo.",
      cancel: "Cancelar",
      save: "Guardar",
      first_name: "Nombre",
      last_name: "Apellido",
      email: "Correo Electrónico",
      phone_number: "Número de Teléfono",
      vat_number: "Número de IVA",
      tax_code: "Código Fiscal",
      address: "Dirección",
      website: "Sitio Web",
      matching_keywords: "Palabras Clave para Coincidencia (separadas por comas)",
      is_credit_card: "Tarjeta de Crédito",
      is_credit_card_sub: "Identifica esta cuenta como tarjeta de crédito.",
      is_shared: "Cuenta Compartida",
      is_shared_sub: "Cuenta conjunta.",
      is_obsolete: "Marcar como Obsoleto / Inactivo",
      is_obsolete_sub: "Ocultar de las listas principales.",
      show_obsolete: "Mostrar Obsoletos",
      color: "Color",
      icon: "Icono",
      currency: "Moneda"
    },
    toasts: {
      deleted: "Elemento eliminado.",
      delete_err: "No se pudo eliminar: {detail}",
      created: "¡Elemento creado!",
      updated: "¡Elemento actualizado!",
      save_err: "Error al guardar: {detail}",
      loading: "Cargando datos maestros..."
    }
  },
  debts_page: {
    title: "Deudas y Créditos",
    subtitle: "Gestiona préstamos a amigos y tus deudas pendientes.",
    new_friend: "Nuevo Amigo",
    new_debt: "Nueva Deuda",
    active_tab: "Por Liquidar",
    settled_tab: "Liquidadas",
    empty_msg: "No hay elementos en esta sección.",
    toasts: {
      load_err: "Error al cargar los datos",
      deleted: "¡Deuda eliminada!",
      delete_err: "No se pudo eliminar",
      contact_created: "Contacto creado",
      debt_created: "Deuda registrada",
      debt_updated: "Deuda actualizada",
      save_err: "Error al guardar",
      status_updated: "¡Estado actualizado!",
      status_err: "Error al actualizar el estado",
      repay_linked: "¡Transacción vinculada!",
      repay_err: "Error",
      link_removed: "¡Enlace eliminado!"
    },
    modal: {
      delete_title: "Eliminar Deuda",
      delete_message: "¿Estás seguro de que quieres eliminar esta de deudat? Esto no cambiará tus saldos reales, pero eliminará el recordatorio.",
      friend_title: "Nuevo Amigo",
      friend_name: "Nombre del Amigo",
      friend_placeholder: "Ej. John Doe",
      cancel: "Cancelar",
      save: "Guardar",
      debt_title: "Deuda",
      debt_amount: "Monto Total",
      debt_desc: "Descripción (Opcional)",
      debt_desc_placeholder: "Ej. Cena de pizza, préstamo...",
      repay_title: "Gestionar Conciliación",
      repay_remaining: "Restante por liquidar: {amount}",
      repay_status: "Estado: {status}",
      repay_settled: "Liquidado",
      repay_active: "Activo",
      repay_history: "Historial de Transacciones Vinculadas",
      repay_amount_applied: "Monto aplicado",
      repay_no_links: "Sin transacciones vinculadas.",
      repay_link_new: "Vincular Nueva Transacción",
      repay_select_tx: "Seleccionar una transacción...",
      repay_amount_to_apply: "Monto a Atribuir a esta Deuda",
      repay_settle_checkbox: "Marcar como liquidada (Cerrar)",
      repay_submit: "Registrar Conciliación",
      toggle_repay_status: "Marcar como {status}",
      type_lent: "Prestado (Crédito)",
      type_borrowed: "Tomado Prestado (Deuda)",
      reopen_debt: "Reabrir Deuda",
      close_debt: "Cerrar Deuda",
      repay_total: "Reembolso",
      remaining_label: "Restante",
      tx_removed: "Transacción Eliminada",
      search_tx: "Buscar Transacción",
      settled_info: "Esta deuda está liquidada actualmente. Usa el botón 'Reabrir Deuda' para agregar nuevas transacciones, o haz clic en el icono de papelera en el historial para eliminar un enlace incorrecto."
    },
    aggregations: {
      credits_title: "Créditos Pendientes",
      debts_title: "Deudas Pendientes",
      net_balance: "Saldo Neto",
      net_credits: "Tienes a favor {amount}",
      net_debts: "Debes {amount}",
      net_balanced: "Los saldos están equilibrados",
      by_friend: "Posición por Amigo",
      friend_credit: "Te debe {amount}",
      friend_debt: "Le debes {amount}",
      friend_settled: "Equilibrado"
    },
    card: {
      lent: "Prestado a",
      borrowed: "Tomado prestado de",
      remaining: "Restante: {amount} de {total}",
      settle_now: "Vincular / Liquidar",
      settled: "Liquidado",
      no_desc: "Sin descripción"
    }
  },
  documents_page: {
    inbox_title: "Buzón de Telegram",
    empty_inbox: "Buzón vacío. ¡Envía un archivo al bot!",
    preview_title: "Vista Previa del Documento",
    fullscreen_btn: "Abrir en pantalla completa",
    decrypting: "Desencriptando archivo...",
    link_section_title: "Vincular a Transacción",
    search_placeholder: "Buscar por descripción o monto...",
    link_btn: "Vincular aquí",
    delete_btn: "Eliminar este archivo",
    delete_confirm: "¿Eliminar el archivo permanentemente?",
    empty_selection: "Selecciona un documento para comenzar",
    other_features_soon: "Otras Funciones (Próximamente)",
    create_asset: "Crear Activo",
    send_to_accountant: "Enviar al Contador",
    archive_title: "Archivo Vinculado",
    tab_inbox: "Inbox",
    tab_archive: "Archivo",
    empty_archive: "No se encontraron documentos vinculados.",
    linked_to: "Vinculado a la transacción:",
    unlink_btn: "Desvincular Transacción",
    select_transaction_title: "Seleccionar Transacción",
    alias_label: "Alias / Nombre personalizado",
    alias_placeholder: "Factura, recibo...",
    save_alias_btn: "Renombrar",
    toasts: {
      preview_err: "No se pudo cargar la vista previa del documento.",
      linked: "¡Documento vinculado!",
      unlinked: "¡Documento desvinculado!",
      alias_updated: "¡Alias actualizado!"
    }
  },
  envelopes_page: {
    title: "Sobres",
    subtitle: "Reserva dinero para gastos futuros y objetivos recurrentes.",
    new_btn: "Nuevo Sobre",
    liquid_title: "Liquidez disponible en cuenta corriente",
    liquid_desc: "Lo que ves en tu aplicación bancaria",
    allocated_title: "Asignado en Sobres",
    allocated_desc: "Dinero ya 'gastado' mentalmente",
    unallocated_title: "Aún Libre (Sin Asignar)",
    unallocated_desc: "Tu VERDADERO patrimonio gastable",
    my_goals: "Tus Sobres",
    empty_msg: "No hay sobres configurados. ¡Crea uno para empezar a presupuestar!",
    toasts: {
      load_err: "Error al cargar los datos",
      deleted: "¡Sobre eliminado!",
      delete_err: "No se pudo eliminar",
      saved: "¡Sobre guardado!",
      save_err: "Error al guardar el sobre"
    },
    card: {
      target: "Objetivo: {target}",
      target_reached: "¡Completado!",
      delete_confirm: "¿Estás seguro de que quieres eliminar este sobre?",
      no_desc: "Sin descripción",
      remaining_to_target: "Restante: {amount}"
    },
    modal: {
      new_title: "Nuevo Sobre",
      edit_title: "Editar Sobre",
      delete_title: "Eliminar Sobre",
      name: "Nombre del Sobre",
      name_placeholder: "Ej. Seguro de Auto, Impuestos...",
      allocated: "Monto Asignado (€)",
      target: "Monto Objetivo (Opcional, €)",
      description: "Notas / Descripción",
      description_placeholder: "Ej. Vence en noviembre, objetivo de ahorro mensual...",
      cancel: "Cancelar",
      save: "Guardar"
    }
  },
  goals_page: {
    title: "Objetivos Financieros",
    subtitle: "Planifica tus metas de ahorro a largo plazo.",
    new_btn: "Nuevo Objetivo",
    allocated_title: "Asignado en Objetivos",
    empty_msg: "No hay objetivos establecidos. ¡Haz clic en 'Nuevo Objetivo' para empezar a ahorrar!",
    toasts: {
      load_err: "Error al cargar los datos",
      deleted: "¡Objetivo eliminado!",
      delete_err: "No se pudo eliminar",
      saved: "¡Objetivo guardado!",
      save_err: "Error al guardar el objetivo",
      select_account: "¡Selecciona una cuenta!",
      alloc_success: "¡Fondos asignados con éxito!",
      alloc_err: "Error de asignación: {detail}"
    },
    card: {
      target: "Objetivo: {amount} para {date}",
      allocated: "Asignado: {amount} ({pct}%)",
      delete_confirm: "¿Estás seguro de que quieres eliminar este objetivo?",
      target_date: "Meta: {date}",
      add_funds: "Añadir Fondos"
    },
    modal: {
      new_title: "Nuevo Objetivo",
      edit_title: "Editar Objetivo",
      delete_title: "Eliminar Objetivo",
      name: "Nombre del Objetivo",
      name_placeholder: "Ej. Comprar Casa, Viaje a Japón...",
      target: "Monto Objetivo (€)",
      deadline: "Fecha Límite",
      notes: "Notas / Descripción",
      notes_placeholder: "Detalles sobre el objetivo...",
      cancel: "Cancelar",
      save: "Guardar",
      allocate_title_prefix: "Mover Fondos a",
      allocate_from_account: "¿DE QUÉ CUENTA RETIRAR?",
      allocate_select_account: "Elegir cuenta...",
      allocate_desc: "El dinero permanecerá en tu Patrimonio Neto, pero se ocultará de la liquidez libre.",
      allocate_amount: "MONTO (€)",
      allocate_date: "FECHA",
      allocate_submit: "Depositar",
      optional: "Opcional"
    }
  },
  investments_page: {
    title: "Inversiones y Portafolio",
    subtitle: "Monitorea activos, calcula PMC y registra transacciones de compra/venta.",
    import_btn: "Importar CSV",
    new_asset_btn: "Nuevo Activo",
    new_order_btn: "Registrar Orden",
    chart_title: "Historial de Rendimiento del Portafolio",
    empty_chart: "No hay datos históricos para el gráfico.",
    positions_title: "Posiciones del Portafolio",
    value: "Valor",
    commission: "Comisiones",
    order_type: "Tipo de Orden",
    date: "Fecha",
    shares: "Acciones",
    price: "Precio",
    orders_history: "Historial de Órdenes",
    loading_msg: "Inicializando terminal...",
    updating_data: "Actualizando datos...",
    broker_selector_all: "Todos los Brokers",
    ledger_empty: "El libro mayor está vacío. Registra tu primera transacción.",
    positions_empty: "No hay posiciones abiertas en el portafolio.",
    assets_empty: "No hay activos registrados.",
    tab_positions: "Posiciones Activas",
    tab_ledger: "Historial de Órdenes (Libro)",
    tab_assets: "Directorio de Activos",
    broker_liquidity: "Liquidez del Broker",
    table: {
      asset: "Activo",
      shares: "Acciones",
      pmc: "PMC",
      current_price: "Precio Actual",
      total_value: "Valor Total",
      unrealized_pnl: "P&L No Realizado",
      date: "Fecha",
      event: "Evento",
      price: "Precio",
      value_eur: "Valor (EUR)",
      actions: "Acciones",
      ticker: "Ticker",
      name: "Nombre",
      type: "Tipo",
      currency: "Moneda",
      last_price: "Último Precio"
    },
    toasts: {
      load_err: "Error al cargar los datos.",
      asset_deleted: "¡Activo eliminado!",
      asset_delete_err: "No se pudo eliminar el activo.",
      order_deleted: "¡Orden eliminada!",
      order_delete_err: "No se pudo eliminar la orden.",
      asset_saved: "¡Activo guardado con éxito!",
      asset_save_err: "Error al guardar el activo.",
      order_saved: "¡Orden registrada con éxito!",
      order_save_err: "Error al guardar la orden.",
      import_success: "¡Importación completada con éxito!",
      import_err: "Error al importar."
    },
    modal: {
      asset_new_title: "Nuevo Activo",
      asset_edit_title: "Editar Activo",
      ticker: "Ticker / Identificador",
      ticker_placeholder: "Ej. SWDA.MI, AAPL, BTC...",
      name: "Nombre del Activo",
      name_placeholder: "Ej. iShares MSCI World, Apple...",
      isin: "Código ISIN (Opcional)",
      isin_placeholder: "Ej. IE00B4L5Y983...",
      asset_class: "Clase de Activo",
      asset_class_placeholder: "Ej. Renta Variable, Cripto, Oro...",
      currency: "Moneda de Cotización",
      currency_placeholder: "EUR, USD, etc.",
      current_price: "Precio de Mercado Actual",
      search_ticker: "Buscar Ticker (Yahoo Finance)",
      ticker_not_found: "Ticker no encontrado en Yahoo Finance.",
      ticker_verified: "Ticker Verificado",
      symbol: "Símbolo",
      instrument_name: "Nombre del Instrumento",
      original_currency: "Moneda Original",
      save_asset_btn: "Guardar Activo en Directorio",
      order_new_title: "Registrar Nueva Orden",
      order_edit_title: "Editar Orden",
      select_asset: "Seleccionar Activo...",
      select_account: "Cuenta de Débito/Crédito...",
      order_type_buy: "COMPRA",
      order_type_sell: "VENTA",
      order_date: "Fecha de la Orden",
      order_shares: "Cantidad (Acciones)",
      order_price: "Precio Unitario (€)",
      order_commission: "Comisión (€, Opcional)",
      broker_account: "Cuenta del Broker",
      event_type: "Tipo de Evento",
      buy_option: "COMPRA (Adquisición)",
      sell_option: "VENTA (Enajenación)",
      deposit_option: "DEPÓSITO (Depositar Efectivo)",
      withdraw_option: "RETIRO (Retirar Efectivo)",
      dividend_option: "DIVIDENDO (Dividendo)",
      interest_option: "INTERÉS (Interés de Efectivo)",
      fee_option: "FEE (Comisión)",
      unit_price: "Precio Unitario",
      total_value_eur: "Valor Total (€)",
      execution_date: "Fecha de Ejecución",
      confirm_order_btn: "Confirmar Orden",
      registering: "Registrando...",
      order_notes: "Notas / Detalles de transacción",
      cancel: "Cancelar",
      save: "Guardar",
      delete_confirm_asset: "¿Estás seguro de que quieres eliminar este activo? Todas las órdenes asociadas también serán eliminadas.",
      delete_confirm_order: "¿Estás seguro de que quieres eliminar esta orden? El PMC y las cantidades serán recalculados.",
      delete_order_title: "Eliminar Orden",
      delete_order_msg: "¿Estás seguro de que deseas eliminar esta orden del Libro Mayor? La operación es irreversible y recalculará inmediatamente las posiciones y gráficos."
    },
    import_page: {
      back_btn: "Volver a Terminal",
      title: "Importar Datos de Broker",
      subtitle: "Gestiona el flujo de importación masiva de tus inversiones.",
      system_aligned: "Sistema Alineado",
      ready_data: "Listo para nuevos datos",
      step_staging: "Paso 1: Área de Preparación (Staging)",
      select_broker: "Seleccionar Broker",
      file_label_csv: "Archivo CSV (Trade Republic)",
      upload_data_btn: "Subir Nuevos Datos",
      step_processing: "Paso 2: Procesamiento",
      processing_desc: "Analiza el área de preparación y crea los eventos reales en el Libro Mayor: compras, ventas, dividendos y comisiones se calcularán al centavo.",
      staging_status: "Estado del Área de Preparación",
      ready_to_process: "Listo para procesar",
      process_ledger_btn: "Procesar Libro Mayor",
      step_sync: "Paso 3: Sincronización",
      sync_desc: "Sincroniza precios históricos desde Yahoo Finance. Solo se descargarán los datos faltantes para optimizar el rendimiento.",
      asset_prices: "Precios de Activos",
      diff_update: "Actualización diferencial",
      smart_backfill_btn: "Smart Backfill",
      footer_info: "ID de transacción detectado a través del transaction_id único del broker.",
      safe_processing: "Procesamiento Seguro",
      dup_check: "Verificación de Duplicados Activa",
      loading_config: "Cargando configuración...",
      toasts: {
        load_acc_err: "No se pudieron cargar las cuentas.",
        select_file_acc: "Por favor selecciona un archivo y una cuenta de destino.",
        uploading_file: "Subiendo archivo al área de preparación...",
        upload_err: "Error durante la subida",
        upload_conn_err: "Error de conexión durante la subida.",
        processing_ledger: "Procesando transacciones y actualizando el Libro Mayor...",
        process_err: "Error al procesar el Libro Mayor.",
        process_conn_err: "Error de conexión durante el procesamiento.",
        syncing_prices: "Sincronizando precios históricos desde Yahoo Finance...",
        backfill_err: "Error durante el relleno de precios.",
        backfill_conn_err: "Error de conexión durante el relleno de precios."
      }
    }
  },
  recurring_page: {
    title: "Suscripciones y Gastos Recurrentes",
    subtitle: "Visualiza y gestiona las salidas planificadas y tus suscripciones recurrentes.",
    new_btn: "Nueva Suscripción",
    active_tab: "Activas",
    inactive_tab: "Desactivadas",
    forecast_title: "Proyecciones de Gastos Futuros",
    forecast_loading: "Calculando proyecciones...",
    forecast_30d: "Gasto en los próximos 30 días",
    forecast_90d: "Gasto en los próximos 90 days",
    forecast_365d: "Gasto en los próximos 365 días",
    empty_msg: "No hay suscripciones configuradas. ¡Añade tu primera suscripción!",
    delete_title: "Eliminar Suscripción",
    stats_7d: "Próximos 7 Días",
    stats_eom: "Para Fin de Mes",
    stats_30d: "Próximos 30 Días",
    stats_next_month: "Mes Próximo",
    stats_12m: "Próximos 12 Meses",
    stats_monthly_avg: "Promedio Mensual",
    toasts: {
      load_err: "Error al cargar los datos",
      deleted: "¡Suscripción eliminada!",
      delete_err: "No se pudo eliminar",
      saved: "¡Suscripción guardada!",
      save_err: "Error al guardar la suscripción"
    },
    card: {
      frequency_label: "Frecuencia:",
      next_date_label: "Siguiente débito:",
      account_label: "Cuenta:",
      status_label: "Estado:",
      active: "Activa",
      inactive: "Inactiva",
      freq_daily: "Diario",
      freq_weekly: "Semanal",
      freq_monthly: "Mensual",
      freq_yearly: "Anual",
      delete_confirm: "¿Estás seguro de que quieres eliminar esta suscripción recurrente?",
      suspend: "Pausar",
      resume: "Reanudar"
    },
    modal: {
      new_title: "Nueva Suscripción",
      edit_title: "Editar Suscripción",
      description: "Descripción / Nombre",
      description_placeholder: "Ej. Netflix, Spotify, Alquiler...",
      amount: "Monto (€)",
      category: "Categoría",
      account: "Cuenta de Débito",
      frequency: "Frecuencia",
      next_date: "Siguiente Fecha de Vencimiento",
      is_active: "Suscripción Activa (Activa futuros cargos)",
      cancel: "Cancelar",
      save: "Guardar",
      none_placeholder: "Ninguno..."
    }
  },
  wishlist: {
    delete_btn: "Eliminar",
    title: "Lista de Deseos (Temporizador)",
    subtitle: "Registra las compras no esenciales para dejarlas 'enfriar' y evitar compras impulsivas.",
    add_btn: "Añadir Deseo",
    new_wish: "Nuevo Deseo",
    name: "Nombre del Objeto",
    name_placeholder: "Ej. Smartwatch, Zapatos nuevos...",
    amount: "Monto (€)",
    category: "Categoría",
    merchant: "Comerciante / Marca",
    merchant_placeholder: "Selecciona un comerciante (opcional)...",
    product_url: "Enlace del Producto",
    product_url_placeholder: "Ej. https://amazon.es/... (opcional)",
    timer: "Período de Reflexión",
    timer_24: "24 Horas",
    timer_48: "48 Horas (Recomendado)",
    timer_72: "72 Horas",
    notes: "Notas Adicionales",
    notes_placeholder: "¿Por qué quiero comprar esto? ¿Realmente lo necesito?",
    cancel: "Cancelar",
    save: "Guardar Deseo",
    total_saved: "Ahorro por Autocontrol",
    active_wishes: "Período de Reflexión Activo",
    archived_wishes: "Historial de Decisiones",
    time_left: "Tiempo restante:",
    expired: "¡Tiempo Agotado!",
    want_it_question: "¿Aún quieres comprarlo?",
    yes_btn: "Sí, todavía lo quiero",
    no_btn: "No, he cambiado de opinión",
    status_pending: "Reflexión",
    status_saved: "Ahorrado",
    status_bought: "Comprado",
    empty_active: "No hay compras en fase de reflexión. ¡Excelente autocontrol!",
    empty_archive: "No hay decisiones registradas en el historial.",
    delete_confirm: "¿Estás seguro de que quieres eliminar este deseo?",
    toasts: {
      load_err: "Error al cargar los deseos",
      saved: "¡Deseo registrado! El temporizador de enfriamiento ha comenzado.",
      save_err: "No se pudo guardar el deseo",
      deleted: "Deseo eliminado",
      delete_err: "No se pudo eliminar",
      decision_saved: "¡Felicitaciones por el autocontrol! Se han movido {amount}€ a tu sobre de Ahorros.",
      decision_bought: "Deseo confirmado. ¡Puedes proceder a la compra!"
    }
  }
};
